import { IDashboard } from "../route.type";
import DashboardPage from "../../modules/dashboard/pages/dashboard.page";
import { TransferPage } from "../../modules/stock-operation/pages/transfer.page";
import { InitialInventoryPage } from "../../modules/stock-operation/pages/initial-inventory.page";
import { DemandInventoryPage } from "../../modules/stock-operation/pages/demand-inventory.page";
import { PendingOperationPage } from "../../modules/stock-operation/pages/pending-operation.page";
import { LogoComponent } from "../../branding/logo.component";
import LocationOperationsPage from "../../modules/report/pages/location-operations.page";
import LocationInventoryPage from "../../modules/report/pages/location-inventory.page";
import DailyProductReportPage from "../../modules/report/pages/daily-product-report.page";
import MonthlyProductReportPage from "../../modules/report/pages/monthly-product-report.page";
import ApprovalOperationDetailsPage from "../../modules/stock-operation/pages/approval-operation-details.page";
import OperationDetailsPage from "../../modules/report/pages/all-operation-details.page";
import { UserProfilePage } from "../../modules/user/pages/user-profile.page";
import { EditTransferPage } from "../../modules/stock-operation/pages/edit-transfer.page";
import { FaClipboardList, FaServer, FaUserFriends } from "react-icons/fa";
import InventoryByDatePage from "../../modules/report/pages/inventory-by-date.page";
import { VendorSupplyPage } from "../../modules/stock-operation/pages/vendor-supply.page";
import { SubstoreInventoryPage } from "../../modules/report/pages/substore.inventory.page";
import { ConsumptionPage } from "../../modules/stock-operation/pages/consumption.page";
import { TrashPage } from "../../modules/stock-operation/pages/trash.page";
import { VendorDemandPage } from "../../modules/stock-operation/pages/vendor-demand.page";
import { AllVendorDemandPage } from "../../modules/report/pages/all-vendor-demand.page";
import { AdjustmentReportPage } from "../../modules/report/pages/adjustment-report.page";
import { DemanFulfillPage } from "../../modules/stock-operation/pages/deman-fulfill.page";
import { SingleProductInventoryPage } from "../../modules/report/pages/single-product-inventory.page";
import { SingleProductMovementByLocationPage } from "../../modules/report/pages/single-product-movement-by-location.page";
import { ChangePasswordPage } from "../../modules/auth/pages/change-password.page";
import { SingleProductMovementByDatePage } from "../../modules/report/pages/single-product-movement-by-date.page";
import { AllNotificationComponent } from "../../modules/notification/component/all-notification.component";
import { LowStockPage } from "../../modules/dashboard/pages/low-stock.page";
import { ToBeExpiredPage } from "../../modules/dashboard/pages/to-be-expired.page";

export const storeManagerDashboard: IDashboard = {
  dashboardName: "STOREMANAGER",
  logo: <LogoComponent />,
  pages: [
    {
      name: "Items To Be expired",
      link: "/store-manager/to-be-expired",
      content: <ToBeExpiredPage />
    },
    {
      name: "Low Stock Products",
      link: "/store-manager/low-stock",
      content: <LowStockPage />
    },
    {
      name: "All Notification",
      link: "/store-manager/notification-all",
      content: <AllNotificationComponent />
    },
    {
      name: "Dashboard",
      link: "/store-manager/dashboard",
      content: <DashboardPage />
    },
    // Operations
    {
      name: "Transfer Operation",
      link: "/store-manager/stock-operation/transfer/create",
      content: <TransferPage />
    },
    {
      name: "Pending Operation",
      link: "/store-manager/stock-operation/pending-operation",
      content: <PendingOperationPage />
    },
    {
      name: "Initial Inventory",
      link: "/store-manager/stock-operation/initial-inventory/crete",
      content: <InitialInventoryPage />
    },
    {
      name: "Vendor Supply",
      link: "/store-manager/stock-operation/vendor-supply/create",
      content: <VendorSupplyPage />
    },
    {
      name: "Vendor Demand",
      link: "/store-manager/stock-operation/vendor-demand/create",
      content: <VendorDemandPage />
    },
    {
      name: "Demand Inventory",
      link: "/store-manager/stock-operation/demand/create",
      content: <DemandInventoryPage />
    },
    {
      name: "Demand Fulfill",
      link: "/store-manager/demand-fulfil/:id",
      content: <DemanFulfillPage />
    },
    {
      name: "Approval Operation Details",
      link: "/store-manager/approval/operation-details",
      content: <ApprovalOperationDetailsPage />
    },
    {
      name: "Edit Transfer Operation",
      link: "/store-manager/stock-operation/transfer/edit/:operationId",
      content: <EditTransferPage />
    },
    {
      name: "Consumption",
      link: "/store-manager/stock-operation/consumption/create",
      content: <ConsumptionPage />
    },
    {
      name: "Trash",
      link: "/store-manager/stock-operation/trash/create",
      content: <TrashPage />
    },
    // Reports
    {
      name: "Location Operations",
      link: "/store-manager/report/location-operations",
      content: <LocationOperationsPage />
    },
    {
      name: "Location Inventory",
      link: "/store-manager/report/location-inventory",
      content: <LocationInventoryPage />
    },
    {
      name: "Sub Location Inventory",
      link: "/store-manager/report/sub-location-inventory",
      content: <SubstoreInventoryPage />
    },
    {
      name: "Inventory By Date",
      link: "/store-manager/report/previous-inventory",
      content: <InventoryByDatePage />
    },
    {
      name: "Daily Product Report",
      link: "/store-manager/report/daily-product-report",
      content: <DailyProductReportPage />
    },
    {
      name: "Monthly Product Report",
      link: "/store-manager/report/monthly-product-report",
      content: <MonthlyProductReportPage />
    },
    {
      name: "Operation Details",
      link: "/store-manager/report/operation-details/:id",
      content: <OperationDetailsPage />
    },
    // My Profile
    {
      name: "Profile",
      link: "/store-manager/profile",
      content: <UserProfilePage />
    },
    {
      name: "Reset Password",
      link: "/store-manager/change-password",
      content: <ChangePasswordPage />
    },
    {
      name: "All Vendor Demand",
      link: "/store-manager/report/all-vendor-demand",
      content: <AllVendorDemandPage />
    },
    {
      name: "Adjustment Report",
      link: "/store-manager/report/adjustment-report",
      content: <AdjustmentReportPage />
    },
    {
      name: "Single Product Inventory",
      link: "/store-manager/report/single-product-inventory",
      content: <SingleProductInventoryPage />
    },
    {
      name: "Single Product Movement (By Location)",
      link: "/store-manager/report/single-product-movement",
      content: <SingleProductMovementByLocationPage />
    },
    {
      name: "Single Product Movement (By Date)",
      link: "/store-manager/report/date-wise-product-movement",
      content: <SingleProductMovementByDatePage />
    }
  ],

  sidebar: [
    {
      name: "Dashboard",
      link: "/store-manager/dashboard",
      content: <DashboardPage />
    },

    {
      header: "Stock Operation",
      icon: FaServer,
      pages: [
        {
          name: "Transfer Operation",
          link: "/store-manager/stock-operation/transfer/create",
          content: <TransferPage />
        },
        {
          name: "Initial Inventory",
          link: "/store-manager/stock-operation/initial-inventory/crete",
          content: <InitialInventoryPage />
        },
        {
          name: "Vendor Supply",
          link: "/store-manager/stock-operation/vendor-supply/create",
          content: <VendorSupplyPage />
        },
        {
          name: "Vendor Demand",
          link: "/store-manager/stock-operation/vendor-demand/create",
          content: <VendorDemandPage />
        },
        {
          name: "Demand Inventory",
          link: "/store-manager/stock-operation/demand/create",
          content: <DemandInventoryPage />
        },
        {
          name: "Consumption",
          link: "/store-manager/stock-operation/consumption/create",
          content: <ConsumptionPage />
        },
        {
          name: "Trash",
          link: "/store-manager/stock-operation/trash/create",
          content: <TrashPage />
        },
        {
          name: "Pending Operation",
          link: "/store-manager/stock-operation/pending-operation",
          content: <PendingOperationPage />
        }
      ]
    },
    {
      header: "Report",
      icon: FaClipboardList,
      pages: [
        {
          name: "Location Operations",
          link: "/store-manager/report/location-operations",
          content: <LocationOperationsPage />
        },
        {
          name: "Location Inventory",
          link: "/store-manager/report/location-inventory",
          content: <LocationInventoryPage />
        },
        {
          name: "Sub Location Inventory",
          link: "/store-manager/report/sub-location-inventory",
          content: <SubstoreInventoryPage />
        },
        {
          name: "Inventory By Date",
          link: "/store-manager/report/previous-inventory",
          content: <InventoryByDatePage />
        },
        {
          name: "Daily Product Report",
          link: "/store-manager/report/daily-product-report",
          content: <DailyProductReportPage />
        },
        {
          name: "Monthly Product Report",
          link: "/store-manager/report/monthly-product-report",
          content: <MonthlyProductReportPage />
        },
        {
          name: "Adjustment Report",
          link: "/store-manager/report/adjustment-report",
          content: <AdjustmentReportPage />
        },
        {
          name: "All Vendor Demand",
          link: "/store-manager/report/all-vendor-demand",
          content: <AllVendorDemandPage />
        },
        {
          name: "Single Product Inventory",
          link: "/store-manager/report/single-product-inventory",
          content: <SingleProductInventoryPage />
        },
        {
          name: "Single Product Movement (By Location)",
          link: "/store-manager/report/single-product-movement",
          content: <SingleProductMovementByLocationPage />
        },
        {
          name: "Single Product Movement (By Date)",
          link: "/store-manager/report/date-wise-product-movement",
          content: <SingleProductMovementByDatePage />
        }
      ]
    },
    {
      header: "User",
      icon: FaUserFriends,
      pages: [
        {
          name: "Profile",
          link: "/store-manager/profile",
          content: <UserProfilePage />
        }
      ]
    }
  ]
};
